module.exports = __webpack_public_path__ + "static/media/038-REC ROOM - toronto.40896831.png";